﻿import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const es: Dictionary = {
  nav: {
    home: "Inicio",
    map: "Mapa",
    tracker: "Rastreador",
    resources: "Recursos",
    fish: "Peces",
    insects: "Insectos",
    birds: "Aves",
    foraging: "Recolección",
    crops: "Cultivos",
    flowers: "Flores",
    animals: "Animales",
    recipes: "Recetas",
    locations: "Ubicaciones",
    npcs: "PNJs",
    shops: "Tiendas",
    guides: "Guías",
    news: "Noticias",
    achievements: "Logros",
    weather: "Clima",
    events: "Eventos",
    pets: "Mascotas",
    dailyChecklist: "Lista Diaria",
    codes: "Códigos de Regalo",
    winterTracker: "Rastreador Invernal",
    support: "Apoyar",
    about: "Acerca de",
    furniture: "Muebles",
    wardrobe: "Ropa",
    buildings: "Construcción",
    resourcesCollection: "Colección",
    resourcesDecorate: "Decorar",
    resourcesExplore: "Explorar",
    resourcesLearn: "Aprender",
    menu: "Menú",
  },
  search: {
    placeholder: "Buscar en todo…",
    categoryItems: "Colección",
    categoryNpcs: "PNJs",
    categoryLocations: "Ubicaciones",
    categoryGuides: "Guías",
    categoryNews: "Noticias",
    categoryAchievements: "Logros",
    noResults: "No se encontraron resultados",
    noResultsHint: "Prueba con otro término de búsqueda",
    navigate: "navegar",
    select: "seleccionar",
    close: "cerrar",
  },
  language: {
    title: "Idioma",
    subtitle: "Elige tu idioma preferido",
  },
  footer: {
    description:
      "Una guía de campo de Heartopia hecha por jugadores para rutas, recetas, ubicaciones y progreso de colección.",
    quickLinks: "Enlaces Rápidos",
    collection: "Colección",
    copyright: "Heartopia Hub",
    disclaimer: "No afiliado con los desarrolladores de Heartopia.",
  },
  home: {
    badge: "Compañero no oficial de Heartopia",
    titleStop: "Deja de",
    titleWandering: "vagar.",
    titleStart: "Empieza a planear.",
    description:
      "Heartopia.guide reúne el mapa de la isla, recetas, criaturas, PNJs y progreso de colección en un solo lugar, tranquilo y rápido.",
    openAtlas: "Abrir atlas",
    tracker: "Rastreador",
    statCatalogued: "Artículos catalogados",
    statLayers: "Capas del mapa",
    statFree: "Siempre gratis",
    islandAtlas: "Atlas de la isla",
    mapLayerNpcs: "PNJs",
    mapLayerShops: "Tiendas",
    mapLayerAnimals: "Animales",
    mapHeading: "Isla de Heartopia",
    mapNearby: "cerca",
    openMap: "Abrir mapa",
    meetLocals: "Conoce a los vecinos",
    hintNpcs: "PNJs listos para hablar, ubicados de un vistazo.",
    hintShops: "Todas las tiendas abastecidas y listas para explorar.",
    hintAnimals: "Animales salvajes deambulando por sus lugares habituales.",
    explore: "Explorar",
    recipesPill: "Recetas",
    recipesTitle: "Cocina mejor",
    recipesDescription: "Explora platos, cadenas de ingredientes y progreso de colección sin abrir diez pestañas.",
    viewRecipes: "Ver recetas",
    ingr: "ingr.",
    profit: "beneficio",
    animalsPill: "Animales salvajes",
    animalsTitle: "Conócelos a todos",
    animalsDescription: "Comidas favoritas, ventanas de clima y pistas de mapa para cada animal salvaje.",
    viewAnimals: "Ver animales",
    guidesPill: "Guías",
    guidesTitle: "Elige un enfoque",
    guidesDescription: "Tres formas de entrar — ve directo a la guía que coincide con lo que buscas en esta sesión.",
    allGuides: "Todas las guías",
    exploreGuide: "Ver guía",
  },
  guides: {
    pillLabel: "Guías de Campo",
    titleLearn: "Aprende",
    titleAccent: "Cada Sistema",
    searchPlaceholder: "Buscar guías…",
    categoryAll: "Todas",
    categoryBeginner: "Principiante",
    categoryCrafting: "Artesanía",
    categoryCooking: "Cocina",
    categoryFishing: "Pesca",
    categoryExploration: "Exploración",
    difficultyEasy: "Fácil",
    difficultyMedium: "Medio",
    difficultyHard: "Difícil",
    allGuides: "Todas las guías",
    by: "Por",
    minRead: "min de lectura",
    noResults: "No se encontraron guías. Prueba otra búsqueda o categoría.",
    relatedGuides: "Guías relacionadas",
    readGuide: "Leer guía",
  },
  news: {
    pillLabel: "Noticias de Heartopia",
    titleWhats: "Qué hay de",
    titleAccent: "Nuevo",
    searchPlaceholder: "Buscar noticias…",
    categoryAll: "Todas",
    categoryEvent: "Evento",
    categoryUpdate: "Actualización",
    categoryGuide: "Guía",
    categoryNews: "Noticia",
    featured: "Destacado",
    allNews: "Todas las noticias",
    read: "Leer",
  },
  map: {
    controls: "Controles del mapa",
    zoomIn: "Acercar",
    zoomOut: "Alejar",
    resetMap: "Restablecer mapa",
    fullscreen: "Pantalla completa",
    viewDetails: "Ver detalles",
    viewLocation: "Ver ubicacion",
    openFullMap: "Abrir mapa completo",
    seeMore: "Ver mas",
    close: "Cerrar",
    back: "Volver",
    guide: "Guia",
    searchPlaceholder: "Buscar PNJs, tiendas, aves, peces...",
    clearSearch: "Limpiar busqueda",
    area: "Area",
    mapArea: "Area del mapa",
    event: "Evento",
    resource: "Recurso",
    location: "Ubicacion",
    npc: "PNJ",
    shop: "Tienda",
    busStop: "Parada de bus",
    wildAnimal: "Animal salvaje",
    focus: "Enfocar",
    hide: "Ocultar",
    show: "Mostrar",
    showAllShops: "Mostrar todas las tiendas",
    showAllAnimals: "Mostrar todos los animales",
    showBugAreas: "Mostrar areas de insectos",
    showBirdAreas: "Mostrar areas de aves",
    showResources: "Mostrar recursos en el mapa",
    showEvents: "Mostrar eventos en el mapa",
    showFishAreas: "Mostrar areas de peces",
    viewAnimalAreas: "Ver areas de animales",
    clickToView: "Clic para ver",
    spots: "puntos",
    meteorShower: "Lluvia de meteoros",
    foundIn: "Encontrado en",
    more: "mas",
    sectionsNpcs: "PNJs",
    sectionsShops: "Tiendas",
    sectionsBusStops: "Paradas de bus",
    sectionsAnimals: "Animales",
    sectionsBugs: "Insectos",
    sectionsBirds: "Aves",
    sectionsResources: "Recursos",
    sectionsWeather: "Clima",
    sectionsEvents: "Eventos",
    sectionsFish: "Peces",
    shopClothes: "Ropa",
    shopFurniture: "Muebles",
    shopPets: "Mascotas",
    shopBookstore: "Libreria",
    helpTitle: "Como usar el mapa",
    helpSearchLead: "Busca",
    helpSearchText: "cualquier PNJ, tienda, criatura o area usando la barra superior.",
    helpLayersLead: "Capas",
    helpLayersText:
      "en la barra lateral alternan lo que aparece en el mapa: PNJs, tiendas, animales, recursos y mas. Toca una categoria para abrir su lista completa.",
    helpClickLead: "Haz clic en un marcador, area o item de la lista",
    helpClickText:
      "para ver informacion basica en la tarjeta inferior del mapa, con boton para abrir la pagina completa cuando exista.",
  },
  locations: {
    title: "Ubicaciones",
    subtitleSuffix: "ubicaciones en toda la Isla de Heartopia",
    openMap: "Abrir Mapa",
    searchPlaceholder: "Buscar ubicaciones…",
    allLocations: "Todas las Ubicaciones",
    npcsHere: "PNJs Aquí",
    shopsHere: "Tiendas Aquí",
    listings: "artículos en venta",
    foundHereTitle: "Encuéntralo Aquí",
    foundHereHint: "Criaturas y recursos que puedes recoger en este lugar.",
    onTheMapTitle: "En el Mapa",
    sameRegionTitle: "Más en la región {region}",
    statNpcs: "NPCs",
    statShops: "Tiendas",
    statCollectibles: "Coleccionables",
    levelShort: "Nv. {level}",
    eventOnly: "Evento",
    seeListings: "Ver artículos",
    seeAll: "Ver todos",
    timeOfDay: "Momento del día",
    nothingHereTitle: "Aún no hay nada registrado aquí",
    nothingHereBody:
      "No tenemos criaturas, tiendas ni NPCs registrados en este lugar. Si has encontrado algo aquí, el mapa es la forma más rápida de mostrarnos dónde.",
    regionTown: "Ciudad",
    regionNature: "Naturaleza",
    regionAdventure: "Aventura",
    regionCoast: "Costa",
    regionSea: "Mar",
    regionRegion: "Región",
    regionFishingVillage: "Pueblo Pesquero",
    regionForest: "Bosque",
    regionMountain: "Montaña",
    regionBeach: "Playa",
    regionOther: "Otros",
  },
  catalog: {
    howItWorks: "Cómo funciona",
    fishPill: "Enciclopedia de Pesca",
    fishTitlePrefix: "Pesca",
    fishTitleAccent: "Cada Pez",
    fishSearchPlaceholder: "Buscar peces, hábitat, tamaño de sombra…",
    fishSliderLabel: "Nivel de Pesca",
    fishIntroTitle: "Pesca 101",
    fishIntroP1:
      "Lanza tu línea cerca del hábitat de un pez para atraparlo — el tamaño de la sombra indica qué está picando.",
    fishIntroP2:
      "Un nivel de pesca más alto desbloquea capturas más raras, y la calidad en estrellas multiplica tu precio de venta.",
    fishUnknownHabitat: "Aguas desconocidas",
    fishHabitat: "Hábitat",
    fishNoResultsTitle: "No se encontraron peces",
    fishNoResultsBody: "Intenta ajustar tus filtros.",
    fishPastEventTitle: "Peces de Eventos Pasados",
    fishHeaderTitle: "Peces",
    fishColFish: "Pez",
    fishColShadow: "Sombra",
    insectsPill: "Enciclopedia de Captura de Insectos",
    insectsTitlePrefix: "Captura",
    insectsTitleAccent: "Cada Insecto",
    insectsSearchPlaceholder: "Buscar insectos, hábitat…",
    insectsSliderLabel: "Nivel de Captura",
    insectsIntroTitle: "Captura de Insectos 101",
    insectsIntroP1: "Usa tu red de insectos cerca del hábitat de un insecto para atraparlo.",
    insectsIntroP2:
      "Un nivel de captura más alto desbloquea insectos más raros, y la calidad en estrellas multiplica tu precio de venta.",
    insectsUnknownHabitat: "Desconocido",
    insectsPastEventTitle: "Insectos de Eventos Pasados",
    insectsHeaderTitle: "Insectos",
    insectsColInsect: "Insecto",
    birdsPill: "Enciclopedia de Observación de Aves",
    birdsTitlePrefix: "Avista",
    birdsTitleAccent: "Cada Ave",
    birdsSearchPlaceholder: "Buscar aves, hábitat…",
    birdsSliderLabel: "Nivel de Observación",
    birdsIntroTitle: "Observación de Aves 101",
    birdsIntroP1: "Espera cerca del hábitat de un ave con tu arbusto de camuflaje para tomar una foto.",
    birdsIntroP2: "Un nivel de observación más alto desbloquea especies más raras.",
    birdsUnknownHabitat: "Desconocido",
    birdsPastEventTitle: "Aves de Eventos Pasados",
    birdsHeaderTitle: "Aves",
    birdsColBird: "Ave",
    cropsPill: "Enciclopedia de Agricultura",
    cropsTitlePrefix: "Cultiva",
    cropsTitleAccent: "Cada Cultivo",
    cropsSearchPlaceholder: "Buscar cultivos…",
    cropsIntroTitle: "Agricultura 101",
    cropsIntroP1: "Planta semillas en tu parcela de granja y riégalas a diario hasta la cosecha.",
    cropsIntroP2:
      "Algunos cultivos solo crecen en ciertas estaciones — revisa la insignia de estación antes de plantar.",
    cropsAllSeasons: "Todas las Estaciones",
    cropsGrowthTime: "Tiempo de Crecimiento",
    cropsGrowthTimeUnknown: "Desconocido",
    cropsGrowthTimeMinutesSuffix: "min",
    cropsSortGrowthTime: "Tiempo de Crecimiento",
    cropsHeaderTitle: "Cultivos",
    cropsColCrop: "Cultivo",
    cropsColSeason: "Estación",
    flowersPill: "Enciclopedia de Jardinería",
    flowersTitlePrefix: "Cultiva",
    flowersTitleAccent: "Cada Flor",
    flowersSearchPlaceholder: "Buscar flores…",
    flowersIntroTitle: "Jardinería 101",
    flowersIntroP1: "Planta semillas de flores y riégalas para que florezcan.",
    flowersHeaderTitle: "Flores",
    flowersColFlower: "Flor",
    furniturePill: "Catálogo de Muebles",
    furnitureTitlePrefix: "Cada",
    furnitureTitleAccent: "Mueble del Juego",
    furnitureSearchPlaceholder: "Buscar muebles…",
    furnitureMetaDescription:
      "Todos los muebles de Heartopia — iluminación, sillas, mesas, camas, alfombras y decoración — filtrables por tipo, habitación y color, con todas las variantes visuales y precios en oro y Estrellas de los Deseos.",
    browseAll: "Todos",
    browseVariants: "{count} diseños",
    browseShowMore: "Mostrar {count} más",
    browseFacetRooms: "Habitación",
    browseFacetColors: "Color",
    browseFacetSlots: "Prenda",
    browseFacetTypes: "Tipo",
    browseFacetSets: "Colecciones",
    browseCollectionsMore: "Ver todas",
    browseCollectionsLess: "Mostrar menos",
    browseCollectionPieces: "{count} piezas",
    browseFavourites: "Favoritos",
    browseNoArt: "El juego no incluye imagen para este",
    browseFacetStyles: "Estilos de construcción",
    buildingsPill: "Catálogo del Modo Construcción",
    buildingsTitlePrefix: "Todas las",
    buildingsTitleAccent: "Piezas de Construcción",
    buildingsSearchPlaceholder: "Buscar puertas, tejados, ventanas…",
    buildingsMetaDescription:
      "Todas las piezas del modo construcción de Heartopia — puertas, ventanas, tejados, vallas, esculturas de pared y texturas de pared y suelo — agrupadas por estilo de construcción, con precios y todas las variantes visuales.",
    wardrobePill: "Catálogo de Ropa",
    wardrobeTitlePrefix: "Cada",
    wardrobeTitleAccent: "Atuendo y Accesorio",
    wardrobeSearchPlaceholder: "Buscar ropa…",
    wardrobeMetaDescription:
      "Todos los sombreros, camisetas, pantalones, zapatos, bolsos y accesorios de Heartopia, filtrables por prenda y color, con precios en oro y Estrellas de los Deseos.",
    forageablesPill: "Enciclopedia de Recolección",
    forageablesTitlePrefix: "Encuentra",
    forageablesTitleAccent: "Cada Recolectable",
    forageablesSearchPlaceholder: "Buscar recolectables…",
    forageablesIntroTitle: "Recolección 101",
    forageablesIntroP1: "Camina por la isla y recoge plantas y hongos silvestres a medida que los encuentres.",
    forageablesEnergy: "Energía",
    forageablesSortEnergy: "Energía",
    forageablesHeaderTitle: "Recolectables",
    forageablesColItem: "Artículo",
    recipesPill: "Lista Maestra de Recetas",
    recipesTitlePrefix: "Cocina",
    recipesTitleAccent: "Cada Plato",
    recipesSearchPlaceholder: "Buscar recetas…",
    recipesIntroTitle: "Cocina 101",
    recipesIntroP1: "Reúne ingredientes y usa una estufa, horno o parrilla para cocinar.",
    recipesIntroP2: "Un nivel de cocina más alto desbloquea recetas más sofisticadas con mayores márgenes de ganancia.",
    recipesSortCookingLevel: "Nivel de Cocina",
    recipesSortProfit: "Ganancia",
    recipesEstProfit: "Ganancia Est.",
    recipesViewRecipe: "Ver receta",
    recipesHeaderTitle: "Recetas",
    recipesColDish: "Plato",
    recipesBeginnerFriendly: "Ideal para Principiantes",
    recipesBestStartersTitle: "Mejores Recetas para Empezar",
    recipesBestStartersSubtitle:
      "Nivel de cocina bajo, buena ganancia — buenas opciones para tus primeros desbloqueos del Hobby de Cocina.",
    npcsPill: "Directorio de Vecinos",
    npcsTitlePrefix: "Conoce",
    npcsTitleAccent: "Cada PNJ",
    npcsSearchPlaceholder: "Buscar PNJs…",
    npcsFilterAll: "Todos",
    npcsFilterMentors: "Mentores",
    npcsFilterShopkeepers: "Tenderos",
    npcsFilterSpecial: "Especiales",
    npcsNoResultsTitle: "No se Encontraron PNJs",
    npcsNoResultsBody: "Intenta ajustar tu búsqueda",
    npcsResetFilters: "Restablecer Filtros",
    locationsPill: "Atlas de la Isla",
    locationsTitlePrefix: "Explora",
    locationsTitleAccent: "Cada Lugar",
    locationsFilterAll: "Todos",
    locationsNoResultsTitle: "No se Encontraron Lugares",
    locationsNoResultsBody: "Intenta ajustar tu búsqueda",
    locationsResetFilters: "Restablecer Filtros",
    shopsPill: "Directorio de Tiendas",
    shopsTitlePrefix: "Cada",
    shopsTitleAccent: "Tienda del Pueblo",
    shopsRunBy: "Administrada por:",
    shopsAt: "En",
    shopsItemsForSale: "artículos en venta",
    shopsSearchPlaceholder: "Buscar tiendas, NPCs, lugares…",
    shopsNoResultsTitle: "No se Encontraron Tiendas",
    shopsNoResultsBody: "Intenta ajustar tu búsqueda",
    shopsResetFilters: "Restablecer Filtros",
    animalsBadge: "Guía de Animales Salvajes",
    animalsTitlePrefix: "Conoce",
    animalsTitleAccent: "Cada Animal",
    animalsPastEvent: "Evento pasado",
    animalsPastEventTitle: "Animales de Eventos Pasados",
    trackerBadge: "Progreso de colección",
    trackerTitle: "Rastreador de Heartopia",
    trackerDescription:
      "Marca peces, insectos, aves, cultivos, flores, recolectables, recetas y animales salvajes como recolectados. El progreso se guarda en este navegador.",
    trackerMetaDescription:
      "Sigue el progreso de tu colección de peces, insectos, aves, cultivos, flores, recolectables, animales y recetas de Heartopia.",
    trackerCategoryTitle: "Rastreador de {category}",
    trackerCategoryMetaDescription:
      "Sigue el progreso de tu colección de {category} en Heartopia — mira qué ya conseguiste, cultivaste o cocinaste, y qué te falta.",
    trackerTotal: "Total",
    trackerExport: "Exportar",
    trackerImport: "Importar",
    trackerReset: "Restablecer",
    trackerImportComplete: "Importación completa.",
    trackerImportFailed: "Error al importar.",
    trackerSearchPlaceholder: "Buscar en la colección...",
    trackerAllCategories: "Todas las categorías",
    trackerAllItems: "Todos los artículos",
    trackerCollected: "Recolectados",
    trackerMissing: "Faltantes",
    trackerNoResults: "Ningún artículo de la colección coincide con los filtros actuales.",
  },
  genericDetail: {
    subtitle: "Entrada de la enciclopedia de objetos",
    sellPrice: "Precio de venta",
    energy: "Energía",
    whereToBuy: "Dónde comprar",
    tags: "Etiquetas",
    crafted: "Fabricado",
    aliases: "También conocido como",
    howToObtain: "Cómo obtenerlo",
    growsInto: "Se convierte en",
    universalIngredientTitle: "Ingrediente de cocina versátil",
    universalIngredientBody: "Se puede usar en lugar de cualquier ingrediente al cocinar una receta.",
  },
  animalDetail: {
    backLabel: "Todos los Animales",
    subtitle: "Entrada de la Guía de Animales Salvajes",
    statLocation: "Ubicación",
    statFavoriteWeather: "Clima Favorito",
    foundInTitle: "Dónde Encontrarlo",
    favoriteFoodsTitle: "Comidas Favoritas",
    noPinTitle: "La ubicación exacta de este animal aún no está marcada.",
    noPinDescription: "Deambula por su área, así que todavía no hemos marcado un punto fijo para él.",
    weatherSunny: "Soleado",
    weatherWet: "Lluvioso",
    weatherRainbow: "Arcoíris",
    weatherSnowy: "Nevado",
    faqTitle: "Preguntas Frecuentes",
  },
  cropDetail: {
    backLabel: "Todos los Cultivos",
    subtitle: "Entrada de la Enciclopedia de Agricultura",
    statGrowthTime: "Tiempo de Crecimiento",
    statSellPrice: "Precio de Venta",
    aboutTitle: "Acerca de",
    seedCostTitle: "Costo de la Semilla",
    usedInRecipesTitle: "Usado en Recetas",
    sellPriceByStarTitle: "Precio de Venta por Estrella",
    faqTitle: "Preguntas Frecuentes",
    shopsTitle: "Dónde Comprar Semillas",
  },
  creatureDetail: {
    allBirds: "Todas las Aves",
    allInsects: "Todos los Insectos",
    allFish: "Todos los Peces",
    birdSubtitle: "Entrada de la Enciclopedia de Observación de Aves",
    insectSubtitle: "Entrada de la Enciclopedia de Captura de Insectos",
    fishSubtitle: "Entrada de la Enciclopedia de Pesca",
    statShadowSize: "Tamaño de la Sombra",
    markAsObtained: "Marcar como obtenido",
    shopsTitle: "Dónde Comprar",
    locationsTitle: "Hábitat",
    sellPriceByStarTitle: "Precio de Venta por Estrella",
    starChanceHint: "Probabilidad de obtener esta cantidad de estrellas",
    statWeightRange: "Peso",
    faqTitle: "Preguntas Frecuentes",
  },
  forageableDetail: {
    backLabel: "Toda la Recolección",
    subtitle: "Entrada de la Enciclopedia de Recolección",
    statEnergy: "Energía",
    shopsTitle: "Dónde Comprar",
    locationsTitle: "Encontrado En",
    aboutBody: "Camina por la isla y recógelo cuando lo encuentres en la naturaleza.",
    faqTitle: "Preguntas Frecuentes",
  },
  flowerDetail: {
    backLabel: "Todas las Flores",
    shopsTitle: "Dónde Comprar Semillas",
    encyclopediaEntry: "Entrada de la Enciclopedia de Jardinería",
    colorsTitle: "Colores",
    otherColorsTitle: "Otros Colores",
    crossbreedingTitle: "Cruce",
    crossbreedingFact1:
      "Solo funciona dentro de la misma especie — una rosa solo se cruza con otra rosa, nunca con un tulipán.",
    crossbreedingFact2:
      "Las flores tienen un nivel de estrella (1-5). Dos padres con la misma estrella pueden producir esa misma estrella o la siguiente; estrellas adyacentes (como 2★ y 3★) funcionan igual. Nada se cruza a través de una brecha mayor, y las flores 5★ ya no producen más semillas.",
    crossbreedingFact3:
      "El color no funciona como ingrediente — los colores de los padres nunca se combinan en un tercer color. Cada color suele pertenecer a un nivel de estrella específico de su especie, así que los colores que consigues dependen más del nivel de estrella que alcances que de los colores iniciales.",
    crossbreedingFact4:
      "Regar aumenta las probabilidades, con un límite de unas 5 personas en total (tú más hasta 4 ayudantes), y tu nivel de Jardinería suma su propia bonificación. Los resultados llegan después del reinicio del servidor a las 6:00.",
    crossbreedingDisclaimer:
      "Los porcentajes exactos de éxito todavía no están documentados públicamente en ningún lugar confiable — avanzar de nivel es posible, nunca garantizado.",
    faqTitle: "Preguntas Frecuentes",
  },
  npcDetail: {
    backLabel: "Todos los NPCs",
    aboutTitle: "Acerca de",
    funFactsTitle: "Datos Curiosos",
    foundInTitle: "Dónde Encontrarlo",
    itemsForSale: "artículos a la venta",
    profileTitle: "Perfil",
    birthdayLabel: "Cumpleaños",
    zodiacLabel: "Signo",
    mbtiLabel: "MBTI",
    likesTitle: "Le Gusta",
    roleLabel: "Rol",
    teachesLabel: "Enseña",
    forSaleLabel: "En Venta",
    townsfolkFallback: "Habitante",
    townsfolkSubtitle: "Habitante de Heartopia",
    itemsSuffix: "artículos",
    noMapPinTitle: "La ubicación exacta de este NPC aún no está marcada.",
    noMapPinDescription: "Se mueve o cambia de lugar, así que todavía no tenemos un marcador fijo para él/ella.",
    currencyGold: "oro",
    currencyStars: "estrellas",
    currencyWishingStars: "estrellas de deseos",
    currencyMoonlightCrystals: "cristales de luna",
    currencyHeartDiamonds: "diamantes de corazón",
    currencyExhibitionPasses: "pases de exhibición",
    currencyContributionMedals: "medallas de contribución",
    seeAllShopItems: "Ver los {count} artículos en {shop} →",
  },
  recipeDetail: {
    faqIngredientsQuestion: "¿Cómo se prepara {name}?",
    faqIngredientsAnswer: "{name} necesita: {ingredients}.",
    faqLevelQuestion: "¿Qué nivel de cocina necesito para {name}?",
    faqLevelAnswer: "Necesitas nivel de cocina {level} para desbloquear {name}.",
    faqSellQuestion: "¿Por cuánto se vende {name}?",
    faqSellAnswer: "{name} se vende por {price} de oro.",
    faqStarQuestion: "¿Cuánto vale un {name} de 5 estrellas?",
    faqStarAnswer: "{name} se vende por {min} de oro con 1★ y {max} con 5★ — {times}× más si el plato sale perfecto.",
    faqEnergyQuestion: "¿Cuánta energía restaura {name}?",
    faqEnergyAnswer: "{name} restaura {min} de energía con 1★ y {max} con 5★.",
    backLabel: "Todas las Recetas",
    subtitle: "Entrada de la Lista de Recetas",
    statCookingLevel: "Nivel de Cocina",
    statTool: "Herramienta",
    statSellPrice: "Precio de Venta",
    shopsTitle: "Dónde Comprar",
    aboutTitle: "Acerca de",
    faqTitle: "Preguntas Frecuentes",
    ingredientsTitle: "Ingredientes",
    noIngredients: "No hay ingredientes registrados para esta receta.",
    missingIngredientsTitle: "No sabemos los ingredientes de esta receta",
    missingIngredientsCta: "Toca para agregarlos",
    suggestIngredientsModalTitle: "Sugerir ingredientes",
    ingredientSearchPlaceholder: "Buscar un artículo…",
    ingredientQtyLabel: "Cant.",
    addIngredientRow: "Agregar ingrediente",
    removeIngredientRow: "Quitar",
    submitIngredients: "Enviar sugerencia",
    submittingIngredients: "Enviando…",
    ingredientsSuccessMessage: "¡Gracias! Revisaremos tu sugerencia pronto.",
    ingredientsErrorMessage: "No se pudo enviar ahora — inténtalo de nuevo más tarde.",
    itemNotFoundCta: "¿No lo encuentras? Sugiere un nuevo artículo",
    newItemPendingBadge: "pendiente",
    suggestNewItemModalTitle: "Sugerir un nuevo artículo",
    newItemNameLabel: "Nombre del artículo",
    newItemNamePlaceholder: "ej.: Mandarina",
    newItemKindLabel: "Categoría",
    newItemNotesLabel: "Notas (opcional)",
    newItemNotesPlaceholder: "Cualquier cosa que nos ayude a agregarlo — dónde se encuentra, cómo es…",
    submitNewItem: "Enviar sugerencia",
    submittingNewItem: "Enviando…",
    newItemSuccessMessage: "¡Gracias! Lo revisaremos y agregaremos pronto.",
    newItemErrorMessage: "No se pudo enviar ahora — inténtalo de nuevo más tarde.",
    anyTag: "cualquiera",
    possibleSubstitutesTitle: "Posibles sustitutos",
    possibleSubstitutesNote:
      "Todos los artículos del catálogo de este tipo — la lista realmente aceptada en el juego puede ser más corta.",
    estIngredientCost: "Costo Est. de Ingredientes",
    estProfit: "Ganancia Est.",
    sellPriceByStar: "Precio de Venta por Estrella",
    starScalingNote: "Escala estándar de cocina (1x/1,5x/2x/4x/8x) — algunos platos usan una tabla diferente.",
    energyByStar: "Energía por Estrella",
    toolStove: "Estufa",
    toolOven: "Horno",
    toolPopcornServingCart: "Carrito de Palomitas",
    toolPenguinStove: "Estufa Pingüino",
    toolBrickServingCart: "Carrito de Ladrillo",
    toolNone: "Ninguna",
  },
  common: {
    loading: "Cargando",
    overviewTitle: "Resumen",
    viewDetails: "Ver detalles",
    cards: "Tarjetas",
    list: "Lista",
    sort: "Ordenar",
    name: "Nombre",
    level: "Nivel",
    price: "Precio de Venta",
    clearFilters: "Limpiar filtros",
    day: "día",
    days: "días",
    shadowSizeSmall: "Pequeña",
    shadowSizeMedium: "Mediana",
    shadowSizeLarge: "Grande",
    shadowSizeGolden: "Dorada",
    usedInRecipesTitle: "Usado en Recetas",
    aboutTitle: "Acerca de",
  },
  itemFaq: {
    whereToFindQuestion: "¿Dónde puedo encontrar {name} en Heartopia?",
    whereToFindByLocationsAnswer: "{name} se puede encontrar en {locations}.",
    whereToFindByHabitatAnswer: "{name} está asociado con el hábitat {habitat}.",
    levelRequiredQuestion: "¿Qué nivel necesito para atrapar {name}?",
    levelRequiredAnswer: "Necesitas al menos el nivel {level} para atrapar {name}.",
    sellPriceQuestion: "¿Por cuánto se vende {name}?",
    sellPriceAnswer: "{name} se vende por {price} de oro.",
    sellPriceWithShadowAnswer: "{name} se vende por {price} de oro, y su tamaño de sombra al pescar es {shadowSize}.",
    weatherQuestion: "¿Qué clima necesito para {name}?",
    weatherAnswer: "{name} aparece durante: {weather}.",
    usedForQuestion: "¿Para qué se usa {name}?",
    usedForAnswer: "{name} restaura {energy} de energía al consumirse.",
  },
  recipeFaq: {
    ingredientsQuestion: "¿Qué ingredientes necesito para {name}?",
    ingredientsAnswer: "{name} necesita: {ingredients}.",
    cookingLevelQuestion: "¿Qué nivel de cocina necesito para {name}?",
    cookingLevelAnswer: "Necesitas nivel {level} de cocina para desbloquear {name}.",
    sellPriceQuestion: "¿Por cuánto se vende {name}?",
    sellPriceAnswer: "{name} se vende por {price} de oro.",
  },
  itemDescription: {
    foundAtClause: "se puede encontrar en {locations}",
    foundInHabitatClause: "está asociado con el hábitat {habitat}",
    requiresLevelClause: "requiere al menos el nivel {level} para obtenerse",
    sellsForClause: "se vende por {price} de oro",
    restoresEnergyClause: "restaura {energy} de energía al consumirse",
    joinWord: "y",
  },
  starTooltip: {
    profitTitle: "Multiplicadores por Estrella",
    profitSubtitle: "Ganancia por clasificación de estrella",
    profitFooterLabel: "1★ Ganancia",
    sellPriceTitle: "Multiplicadores por Estrella",
    sellPriceSubtitle: "Precio de venta por clasificación de estrella",
    sellPriceFooterLabel: "1★ Precio de Venta",
  },
  mastery: {
    trackFishing: "Maestría de Pesca",
    trackBugCatching: "Maestría de Insectos",
    trackBirdwatching: "Maestría de Observación de Aves",
    trackFarming: "Maestría de Agricultura",
    trackCooking: "Maestría de Cocina",
    unitCatches: "capturas",
    unitCaptures: "registros",
    unitHarvests: "cosechas",
    unitPreparations: "preparaciones",
    rankNovice: "Novato",
    rankExpert: "Experto",
    rankMaster: "Maestro",
    trophyUnlocked: "Trofeo",
    footerHint: "Toca un nivel para marcar tu progreso. Llega a Maestro para desbloquear el trofeo.",
    unknownBody: "Todavía no sabemos las metas de maestría de este objeto.",
    unknownCta: "¿Las conoces? Cuéntanos",
    suggestFieldLabel: "Meta de maestría Novato",
    suggestHint: "Solo el número de Novato — en todos los objetos confirmados, Experto es 3x y Maestro 6x ese valor.",
  },
  statSuggestion: {
    unknownLabel: "Todavía no lo sabemos",
    suggestValueCta: "Sugerir un valor",
    explainer:
      "Todavía no confirmamos este dato. Si lo sabes por jugar, compártelo abajo — cada sugerencia se revisa antes de publicarse, así que no hace falta estar 100% seguro.",
    genericHint: "Solo el número, sin necesidad de formato adicional.",
    energyHint: "La cantidad de energía que se restaura al consumir este objeto.",
    sellPriceHint: "El precio de venta base (1 estrella), en Gold — calculamos el resto a partir de eso.",
    habitatHint: "Dónde se encuentra — el nombre del lugar o área.",
    growthTimeHint: "En minutos (ej: 90 para 1h30m, 1440 para 1 día).",
    valueLabel: "Valor",
    customOption: "Otro (escribe el tuyo)",
    habitatTranslationFieldLabel: "Nombre del hábitat en este idioma",
    habitatTranslationHint: "Cómo se llama este lugar/área en este idioma.",
    submitButton: "Enviar sugerencia",
    submitting: "Enviando…",
    successMessage: "¡Gracias! Revisaremos tu sugerencia pronto.",
    errorMessage: "No se pudo enviar ahora — inténtalo de nuevo más tarde.",
  },
  imageSuggestion: {
    triggerLabel: "Sugerir una imagen",
    triggerLabelReplace: "Sugerir una imagen diferente",
    fieldLabel: "Sugerir una imagen",
    explainer:
      "Todavía no tenemos una imagen confirmada para esto. Sube una que tengas — cada sugerencia se revisa antes de agregarse al sitio.",
    explainerReplace:
      "¿Crees que esta imagen está mal o podría ser mejor? Sube una que tengas — cada sugerencia se revisa antes de reemplazar la imagen actual.",
    pickFile: "Elige una foto (JPEG, PNG o WebP)",
    hint: "Máximo 5MB. Asegúrate de que la imagen sea realmente de este ítem.",
    invalidType: "Solo se aceptan imágenes JPEG, PNG o WebP.",
    tooLarge: "La imagen debe pesar 5MB o menos.",
    submitButton: "Enviar imagen",
    submitting: "Subiendo…",
    successMessage: "¡Gracias! Revisaremos tu imagen pronto.",
    errorMessage: "No se pudo subir ahora — inténtalo de nuevo más tarde.",
  },
  generalFeedback: {
    triggerLabel: "¿Algo mal? Sugiere una corrección",
    fieldLabel: "¿Qué está mal?",
    hint: "Descripción incorrecta, imagen incorrecta, cualquier cosa — dinos qué corregir.",
  },
  pageFeedback: {
    triggerLabel: "Reportar un problema con esta página",
    fieldLabel: "¿Qué está mal?",
    hint: "Error de escritura, paso roto, información desactualizada — avísanos.",
    explainer:
      "Todavía no confirmamos esto. Si notaste algo raro, compártelo abajo — cada envío se revisa antes de actuar, así que no hace falta estar 100% seguro.",
    submitButton: "Enviar comentario",
    submitting: "Enviando…",
    successMessage: "¡Gracias! Le echaremos un vistazo pronto.",
    errorMessage: "No se pudo enviar ahora — inténtalo de nuevo más tarde.",
  },
  mapAreaUnknown: {
    title: "Todavía no sabemos dónde está.",
    description: "Ayuda a la comunidad aportando la ubicación de este ítem.",
    cta: "Ayúdanos a añadirlo",
    fieldLabel: "Ubicación / área",
    hint: "Describe dónde lo encontraste — el nombre del lugar y algún punto de referencia cercano.",
    notPinnedTitle: "Este lugar todavía no está marcado en el mapa.",
    notPinnedDescription: "Conocemos el área general, pero aún no hemos mapeado un marcador exacto para ella.",
  },
  itemGuides: {
    title: "Guías Relacionadas",
  },
  itemFallback: {
    badge: "Traducción pendiente",
    message: "Todavía no sabemos el nombre de este artículo en este idioma.",
    usingEnglish: "Usando el inglés:",
    helpMessage: "Todavía no sabemos el nombre de este artículo. ¿Quieres ayudarnos?",
    helpCta: "Ayudar a traducir",
    modalTitle: "Sugerir una traducción",
    fieldPlaceholder: "Nombre del artículo en este idioma",
    submitButton: "Enviar sugerencia",
    submitting: "Enviando…",
    successMessage: "¡Gracias! Revisaremos tu sugerencia pronto.",
    errorMessage: "No se pudo enviar ahora — inténtalo de nuevo más tarde.",
  },
  notFoundPage: {
    title: "404",
    subtitle: "Vaya, esta página no fue encontrada.",
    description: "Has caído en un área que todavía no existe en Heartopia. Volvamos al camino correcto.",
    primaryCta: "Volver al inicio",
    secondaryCta: "Ver mapa del mundo",
  },
  achievements: {
    pill: "Logros",
    titlePrefix: "Desbloquea cada",
    titleAccent: "logro",
    subtitle: "Sigue tu progreso y descubre cómo desbloquear cada logro en Heartopia.",
    searchPlaceholder: "Buscar logros…",
    filterAll: "Todos",
    showHidden: "Mostrar ocultos",
    hideHidden: "Ocultar",
    statTotal: "Total",
    statCompleted: "Completados",
    statHidden: "Ocultos",
    noResultsTitle: "No se encontraron logros",
    noResultsBody: "Prueba con otra búsqueda o filtro.",
    resetFilters: "Limpiar filtros",
    lockedTitle: "???",
    lockedBody: "Este logro todavía es un misterio.",
    titleGainedLabel: "Título obtenido",
    hintLabel: "Pista",
    notesLabel: "Notas",
    markDone: "Marcar como completado",
    markNotDone: "Desmarcar",
    backToList: "Volver a Logros",
    relatedTitle: "Logros relacionados",
    faqTitle: "Preguntas Frecuentes",
  },
  share: {
    title: "Compartir",
    shareVia: "Compartir vía…",
    copyLink: "Copiar enlace",
    linkCopied: "¡Copiado!",
  },
  weather: {
    pill: "Estación del Clima",
    titlePrefix: "Pronóstico",
    titleAccent: "Heartopia",
    subtitle: "Revisa las condiciones para planear tu ruta, identificar eventos y prepararte para apariciones raras.",
    directoryTitle: "Guías de Clima y Eventos",
    specialEvent: "Evento Especial",
    openGuide: "Abrir Guía",
    backToWeather: "Volver al Clima",
    overviewTitle: "Resumen",
    checklistTitle: "Si Solo Tienes 10 Minutos",
    activitiesTitle: "Actividades Clave",
    bestForTitle: "Ideal Para",
    creaturesTitle: "Disponibles en Este Clima",
    creaturesMore: "más",
    creaturesShowLess: "Mostrar menos",
    noCreaturesData: "Todavía no tenemos criaturas etiquetadas para este clima.",
    faqTitle: "Preguntas Frecuentes",
  },
  events: {
    pill: "Calendario de Heartopia",
    titlePrefix: "Eventos",
    titleAccent: "Activos",
    subtitle:
      "Desde grandes festivales estacionales hasta minijuegos diarios rápidos, encuentra todo lo que pasa en Heartopia.",
    minigamesTitle: "Minijuegos Recurrentes",
    seasonalTitle: "Eventos Estacionales y Colaboraciones",
    activeLabel: "Activo",
    endedLabel: "Finalizado",
    viewEvent: "Ver Evento",
    backToEvents: "Volver a Eventos",
    requirementsTitle: "Requisitos",
    locationTitle: "Ubicación",
    costTitle: "Costo de Entrada",
    freeLabel: "Gratis",
    dgLevelLabel: "Nivel del Gremio de Desarrolladores",
    questLabel: "Misión",
    hobbyLabel: "Afición",
    quickFactsTitle: "Datos Rápidos",
    unlockLabel: "Desbloqueo",
    npcAreaLabel: "PNJ / Área",
    durationLabel: "Duración",
    typeLabel: "Tipo",
    howToStartTitle: "Cómo Empezar",
    howItWorksTitle: "Cómo Funciona",
    goalsRewardsTitle: "Objetivos y Recompensas",
    tipsTitle: "Consejos / Estrategia",
    datesTitle: "Fechas del Evento",
    overviewTitle: "Resumen",
    highlightsTitle: "Destacados",
    standoutRewardTitle: "Recompensa Destacada",
    faqTitle: "Preguntas Frecuentes",
  },
  pets: {
    hubBadge: "Guía de Mascotas",
    hubTitlePrefix: "Mascotas de",
    hubTitleAccent: "Heartopia",
    hubSubtitle: "Todo lo que necesitas para desbloquear, adoptar y cuidar mascotas.",
    hubUnlockTitle: "Desbloquear Cuidado de Mascotas",
    hubUnlockDesc: "Generalmente en el Nivel 12 de Desarrollador/Miembro mediante Solicitudes de Residentes.",
    hubOrderTitle: "Gato Primero",
    hubOrderDesc: "Debes adoptar un gato antes de que se desbloqueen los perros.",
    hubRotationTitle: "Rotación Diaria",
    hubRotationDesc: "3 gatos + 3 perros rotan cada día en el Centro de Adopción.",
    cardDogsTitle: "Perros",
    cardDogsSubtitle: "Razas • Cuidado • Grupos",
    cardDogsDesc: "37 razas con grupos de tamaño y notas de cuidado.",
    cardCatsTitle: "Gatos",
    cardCatsSubtitle: "Razas • Rasgos • Pelajes",
    cardCatsDesc: "18 razas con variantes de pelaje y colores.",
    cardTraitsTitle: "Rasgos",
    cardTraitsSubtitle: "Todos los rasgos + búsqueda",
    cardTraitsDesc: "Lista buscable de rasgos y sus efectos.",
    cardGuideTitle: "Guía",
    cardGuideSubtitle: "Desbloquear • Adoptar • Cuidar",
    cardGuideDesc: "Flujo de desbloqueo más la rutina diaria de adopción/cuidado.",
    dogsBadge: "Guía de Perros",
    dogsTitlePrefix: "Perros de",
    dogsTitleAccent: "Heartopia",
    dogsSubtitle: "Desbloquea, adopta y cuida perros con un catálogo de razas organizado.",
    catsBadge: "Guía de Gatos",
    catsTitlePrefix: "Gatos de",
    catsTitleAccent: "Heartopia",
    catsSubtitle: "Razas, rasgos y cuidados — organizados y separados.",
    quickInfoRotationTitle: "Rotación Diaria",
    quickInfoRotationDesc: "3 gatos + 3 perros rotan cada día.",
    quickInfoUnlockTitle: "Desbloqueo",
    quickInfoUnlockDesc: "El Cuidado de Perros se abre después del Cuidado de Gatos.",
    quickInfoOrderTitle: "Gato Primero",
    quickInfoOrderDesc: "Los gatos se desbloquean antes que los perros.",
    quickInfoTraitsTitle: "Rasgos Aleatorios",
    quickInfoTraitsDescDogs: "Los rasgos son aleatorios, no ligados a la raza.",
    quickInfoTraitsDescCats: "Los rasgos son aleatorios y centrados en el comportamiento.",
    searchPlaceholder: "Buscar razas…",
    filterAll: "Todas",
    filterSmall: "Pequeño",
    filterMedium: "Mediano",
    filterLarge: "Grande",
    noResults: "No se encontraron razas",
    traitsBadge: "Rasgos de Mascotas",
    traitsTitlePrefix: "Todos los",
    traitsTitleAccent: "Rasgos",
    traitsSubtitle: "Cada rasgo que puede tener una mascota y qué significa para el cuidado diario.",
    traitsSearchPlaceholder: "Buscar rasgos…",
    effectLabel: "Efecto",
    guideBadge: "Cuidado de Mascotas",
    guideTitlePrefix: "Guía de",
    guideTitleAccent: "Adopción",
    guideSubtitle: "Desbloquea el cuidado de mascotas, adopta tu primer gato y luego expande a los perros.",
    guideStepsTitle: "Cómo Desbloquear",
    guideAdoptionTitle: "Cómo Funciona la Adopción",
    guideCareTitle: "Rutina Diaria de Cuidado",
    backToPets: "Volver a Mascotas",
    viewBreed: "Ver Raza",
    groupLabel: "Tamaño",
    dogLabel: "Perro",
    catLabel: "Gato",
    variantsLabel: "Variantes de Pelaje Conocidas",
    suggestTitle: "¿Falta una raza o información?",
    suggestDogsBody: "Ayuda a ampliar el catálogo de perros con una raza, variante o corrección.",
    suggestCatsBody: "Ayuda a ampliar el catálogo de gatos con una raza, variante de pelaje o corrección.",
    suggestButton: "Sugerir entrada",
    suggestFieldLabel: "Información de la mascota",
    suggestHint: "Comparte la raza, variante, fuente o corrección que conozcas.",
    viewAllTraits: "Ver todos los rasgos",
  },
  dailyChecklist: {
    badge: "Rastreador Diario",
    titlePrefix: "Heartopia",
    titleAccent: "Diaria",
    subtitle: "Sigue tus tareas diarias, recursos y rotaciones de tiendas. Todo se reinicia con un nuevo día.",
    progressTitle: "Progreso Diario",
    progressComplete: "completado",
    allDone: "¡Felicidades! ¡Has completado todas las tareas de hoy!",
    quickTasksTitle: "Tareas Rápidas",
    quickTasksDesc: "Acciones diarias esenciales que se reinician cada día.",
    shopsTitle: "Rotación de Tiendas",
    shopsDesc: "Revisa el inventario rotativo de estos vendedores.",
    resetInfo: "Se reinicia automáticamente según tu fecha local.",
    customTitle: "Tareas Personalizadas",
    addCustom: "Añadir",
    customPlaceholder: "Nombre de la tarea…",
    customEmpty: "Todavía no hay tareas personalizadas.",
    remove: "Eliminar",
  },
  codes: {
    badge: "Centro de Canje",
    title: "CÓDIGOS",
    titleAccent: "DE REGALO",
    subtitle: "¡Canjea estos códigos en el juego para recibir recompensas especiales, oro y objetos exclusivos!",
    statActive: "Activos",
    statExpired: "Expirados",
    statTotal: "Total",
    howToTitle: "Cómo Canjear",
    howToStep1: "Abre el menú del juego",
    howToStep2: "Toca en 'Configuración' > 'Canjear Código'",
    howToStep3: "Ingresa el código exactamente como se muestra",
    howToStep4: "¡Confirma y recibe tus recompensas!",
    rewardsLabel: "Recompensas",
    noRewardsLabel: "Sin recompensas indicadas",
    starQualityHint: "Este código entrega el objeto con una calidad de estrella específica.",
    unconfirmedRewardHint:
      "Todavía no tenemos este objeto en nuestro catálogo, así que este es el id bruto del juego y no un nombre confirmado.",
    expiredText: "Este código ha expirado y ya no se puede canjear.",
    copyCode: "Copiar código",
    copied: "¡Copiado!",
    statusActive: "ACTIVO",
    statusExpired: "EXPIRADO",
    redeemedLabel: "Canjeado",
    markRedeemed: "Marcar como canjeado",
    unmarkRedeemed: "Desmarcar canje",
    goldLabel: "Oro",
    starLabel: "Estrella de los Deseos",
    heartLabel: "Cristal Lunar",
    maintenanceNote:
      "Los códigos se verifican periódicamente, pero pueden expirar sin aviso — si uno no funciona en el juego, probablemente esté desactualizado.",
  },
  winterTracker: {
    badge: "Diario Fashionwave",
    titlePrefix: "Rastreador de Objetos",
    titleAccent: "de Escarcha Invernal",
    subtitle:
      "Sigue cada objeto de edición limitada de la temporada de Escarcha Invernal — este evento ya terminó, pero todavía puedes explorar lo que estaba disponible.",
    endedNote:
      "Este evento ya terminó — los objetos mostrados aquí ya no se pueden obtener en el juego. Se mantiene como referencia de lo que estaba disponible.",
    searchPlaceholder: "Buscar objetos…",
    filterAll: "Todos",
    filterAccessory: "Accesorios",
    filterBag: "Bolsos",
    filterClothing: "Ropa",
    filterFurniture: "Muebles",
    filterEmote: "Emotes",
    filterVehicle: "Vehículos",
    filterTool: "Herramientas",
    filterPet: "Objetos de Mascota",
    filterPuzzle: "Rompecabezas",
    collected: "Recolectado",
    missing: "Faltante",
    noResults: "No se encontraron objetos",
    costLabel: "Fichas Fashionwave",
    backToEvent: "Volver a Escarcha Invernal",
  },
  support: {
    badge: "Apoya heartopia.guide",
    titlePrefix: "Mantén el",
    titleAccent: "Corazón",
    titleSuffix: "Latiendo",
    subtitle:
      "heartopia.guide es un proyecto hecho con pasión para la comunidad. ¡Tu apoyo ayuda a mantener los servidores funcionando y las actualizaciones llegando!",
    donateCta: "Apoyar el Proyecto",
    donateDescription: "Cada contribución ayuda a cubrir el hosting, el dominio y el tiempo de desarrollo.",
    creatorLabel: "Lucas Diniz",
    creatorRole: "Creador de heartopia.guide",
    creatorBadge: "Desarrollador y Diseñador",
    footerNote: "¡Gracias por ser parte de este viaje!",
  },
  about: {
    badge: "Proyecto de Fans · No Oficial",
    title: "Sobre Heartopia Guide",
    subtitle:
      "Heartopia Guide es un sitio hecho por la comunidad para ayudar a los jugadores a encontrar información útil del juego — guías, rastreadores, listas de tareas, objetos y referencias de eventos — de forma rápida y organizada.",
    lastUpdatedLabel: "Última actualización",
    pillEventTrackers: "Rastreadores de Eventos",
    pillGuides: "Guías",
    pillChecklists: "Listas de Tareas",
    pillAlwaysUpdated: "Siempre Actualizado",
    whatYouFindTitle: "Qué vas a encontrar aquí",
    whatYouFind1: "Rastreadores de eventos y listas de objetos (cuando estén disponibles)",
    whatYouFind2: "Guías y páginas de referencia sobre mecánicas del juego",
    whatYouFind3: "Páginas útiles para facilitar rutinas diarias/semanales",
    whatYouFind4: "Un sitio que evoluciona con el tiempo — actualizado a medida que surge nueva información",
    transparencyTitle: "Transparencia y aviso de proyecto de fans",
    transparencyP1:
      "Este es un proyecto de fans independiente y no oficial. No estamos afiliados, patrocinados ni respaldados por los creadores o editores de Heartopia.",
    transparencyP2: "Todas las marcas, nombres y recursos pertenecen a sus respectivos dueños.",
    creatorTitle: "Quién está detrás de esto",
    creatorIntro: "heartopia.guide no es un proyecto anónimo — está creado y mantenido por una persona real.",
    creatorName: "Lucas Diniz",
    creatorRole: "Creador y desarrollador de heartopia.guide",
    creatorLinkLabel: "lucashdo.com",
    sourcesTitle: "De dónde viene la información",
    sourcesIntro: "La información puede provenir de:",
    sourcesItem1: "Observación y pruebas dentro del juego",
    sourcesItem2: "Contribuciones de la comunidad",
    sourcesItem3: "Actualizaciones oficiales del juego",
    sourcesNote:
      "Incluso con cuidado, algunos datos pueden estar incompletos o desactualizados — especialmente durante eventos activos.",
    adsTitle: "Anuncios y sostenibilidad",
    adsP1:
      "Para mantener el sitio funcionando y cubrir costos (dominio, hosting, herramientas), podemos mostrar publicidad.",
    adsP2:
      "Los servicios publicitarios como Google pueden usar cookies o tecnologías similares para mostrar y medir anuncios.",
    copyrightTitle: "Derechos de autor",
    copyrightText:
      "Si eres titular de derechos y crees que algún contenido debe eliminarse o ajustarse, contáctanos con la(s) URL(s) relevante(s) y los detalles. Revisaremos y actuaremos lo más rápido posible.",
    contactTitle: "Contacto",
    contactEmailLabel: "Correo",
    footerNote: "Hecho con cariño por la comunidad Heartopia",
  },
  legal: {
    lastUpdatedLabel: "Última actualización",
    lastUpdatedValue: "2026-02-13",
    contactHeading: "Contacto",
    contactLinkLabel: "página Acerca de y Contacto",
    privacyTitle: "Política de Privacidad",
    privacyIntro:
      "Esta Política de Privacidad explica cómo heartopia.guide recopila, usa y protege información personal cuando accedes a este sitio.",
    privacyDataHeading: "Datos que podemos recopilar",
    privacyData:
      "Dependiendo de cómo uses el sitio, podemos recopilar: datos de navegación/uso (páginas vistas, clics, fecha/hora, referencia, tipo de dispositivo/navegador, idioma); identificadores técnicos (por ejemplo, IP en registros, datos de seguridad y rendimiento); cookies y tecnologías similares (consulta la Política de Cookies); y datos que proporciones (por ejemplo, si nos envías un correo o comentarios). No solicitamos datos sensibles (por ejemplo, salud, religión, biometría).",
    privacyHowWeUseHeading: "Cómo usamos los datos",
    privacyHowWeUse:
      "Usamos los datos para proporcionar y mantener el sitio web, mejorar el contenido y el rendimiento, prevenir abusos y fraudes, responder mensajes y soporte, medir la audiencia cuando esté habilitado, y mostrar anuncios (si corresponde) y medir el rendimiento.",
    privacySharingHeading: "Compartir",
    privacySharing:
      "Podemos compartir datos con proveedores de servicios (hosting, análisis, CDN y/o publicidad) para operar el sitio; cuando sea legalmente requerido (órdenes judiciales, obligaciones regulatorias); y para proteger el sitio y a los usuarios. No vendemos información personal.",
    privacyRetentionHeading: "Retención",
    privacyRetention:
      "Conservamos los datos solo el tiempo necesario para los fines descritos (o según lo exija la ley). Los registros técnicos pueden conservarse por períodos limitados para seguridad y diagnóstico.",
    privacyRightsHeading: "Tus derechos",
    privacyRights:
      "Puedes solicitar los derechos aplicables bajo las leyes correspondientes (por ejemplo, acceso, corrección, eliminación, portabilidad cuando corresponda, información sobre el intercambio, retiro del consentimiento). Para ejercer tus derechos, contáctanos a través de la página de contacto con los detalles de tu solicitud.",
    privacyAdvertisingHeading: "Publicidad",
    privacyAdvertising:
      "Usamos servicios de publicidad de terceros, incluyendo Google AdSense. Estos proveedores pueden usar cookies e identificadores similares para mostrar anuncios, incluyendo anuncios personalizados basados en tus visitas anteriores a este sitio y otros sitios web.\n\nPuedes optar por no recibir publicidad personalizada a través de la Configuración de Anuncios de Google y/o AboutAds (exclusión de publicidad basada en intereses). Los anuncios no personalizados aún pueden mostrarse según el contenido general y la ubicación.",
    privacyContactBefore: "Para preguntas o para ejercer tus derechos, usa nuestra ",
    termsTitle: "Términos de Uso",
    termsIntro:
      'Al acceder a este sitio (el "Sitio"), aceptas estos Términos. El Sitio proporciona contenido informativo y herramientas para la comunidad. Aceptas usarlo de forma legal y respetuosa.',
    termsUseHeading: "Propiedad intelectual y marcas registradas",
    termsUse:
      "El contenido original del Sitio (texto, estructura, diseño) pertenece a heartopia.guide salvo que se indique lo contrario. Heartopia, nombres de personajes/objetos, marcas registradas y recursos referenciados pertenecen a sus respectivos dueños. Puede aparecer contenido de terceros como referencia; si eres titular de derechos y deseas su eliminación o ajuste, contáctanos.",
    termsLiabilityHeading: "Descargo y limitación de responsabilidad",
    termsLiability:
      'El Sitio se proporciona "tal cual". El contenido puede estar incompleto, desactualizado o temporalmente no disponible. No garantizamos disponibilidad continua ni precisión total. En la medida permitida por la ley, no somos responsables de daños indirectos, pérdida de datos, pérdida de ganancias u otras pérdidas derivadas del uso del Sitio. Podemos actualizar el Sitio y estos Términos en cualquier momento; el uso continuado después de los cambios implica aceptación.',
    termsContactBefore: "Para preguntas o solicitudes, usa nuestra ",
    cookiesTitle: "Política de Cookies",
    cookiesIntro:
      "Esta Política de Cookies explica cómo heartopia.guide usa cookies y tecnologías similares para reconocer visitantes y mejorar la experiencia.",
    cookiesWhatAreHeading: "Qué son las cookies",
    cookiesWhatAre:
      "Las cookies son pequeños archivos de texto almacenados en tu navegador cuando visitas un sitio web. Ayudan con la funcionalidad, las preferencias y las estadísticas de uso.",
    cookiesHowWeUseHeading: "Cómo usamos las cookies",
    cookiesHowWeUse:
      "Podemos usar cookies para: Esenciales (obligatorias) — necesarias para la funcionalidad principal del sitio (seguridad, rendimiento, preferencias críticas). Preferencias — por ejemplo, idioma, tema, filtros. Análisis — para entender cómo se usa el sitio y mejorar el contenido. Publicidad (si corresponde) — los socios pueden usar cookies para medir el rendimiento y personalizar anuncios.",
    cookiesThirdPartyHeading: "Cookies de terceros",
    cookiesThirdParty:
      "Podemos usar servicios de terceros (por ejemplo, hosting, análisis, CDNs, redes publicitarias). Estos proveedores pueden establecer sus propias cookies. Puedes revisarlas o gestionarlas a través del banner de consentimiento del sitio.",
    cookiesConsentHeading: "Consentimiento y control",
    cookiesConsent:
      "Puedes controlar las cookies a través del banner de consentimiento que aparece en tu primera visita, la configuración del navegador (bloquear o eliminar cookies), o el modo privado/incógnito. Bloquear cookies esenciales puede afectar funciones del sitio.",
    cookiesContactBefore: "Para preguntas sobre cookies, usa nuestra ",
    sitemapTitle: "Mapa del Sitio",
    sitemapIntro: "Secciones y páginas principales de heartopia.guide.",
    sitemapXmlLabel: "sitemap.xml",
    sitemapXmlNote: "para motores de búsqueda",
    sitemapResourcesHeading: "Recursos",
    sitemapSupportHeading: "Apoyo",
    sitemapLegalHeading: "Legal",
  },
  consent: {
    bannerLabel: "Consentimiento de cookies",
    message:
      "Usamos cookies para funciones esenciales del sitio y, si lo permites, para medir el uso y mostrar anuncios.",
    learnMore: "Saber más sobre las cookies",
    acceptCta: "Aceptar todo",
    rejectCta: "Rechazar no esenciales",
  },
};

export default es;
